/*

  Usage:

  useWillMount(() => {
    form.on('mount', handler)

    return () => {
      form.off('mount', handler)
    }
  })

 */

import { useRef, useEffect } from 'react'


const useWillMount = (fn) => {
  const ref = useRef(false)
  const callbackRef = useRef<() => void>(null)

  if (!ref.current) {
    ref.current = true

    if (typeof fn === 'function') {
      callbackRef.current = fn()
    }
  }

  useEffect(() => callbackRef.current, [])

  return ref.current
}


export default useWillMount
